import React from 'react';
import { RouteComponent } from 'react-resource-router';

import { SiteBannerProvider } from '@townsquare/site-banner';

export function EmbedRoute() {
  return (
    <SiteBannerProvider>
      <RouteComponent />
    </SiteBannerProvider>
  );
}
